import {
  DEFAULT_CINEMA_HANDLER,
  DEFAULT_CINEMA_LANGUAGE,
  isValidCinemaLang,
  isValidCinemaSlug,
} from "~/utils/constants";
import { endingSlash } from "~/utils/route";

export const useCinemaUrl = () => {
  const route = useRoute();

  const lang = computed(() => {
    const param = route.params?.lang;
    return isValidCinemaLang(param) ? param : DEFAULT_CINEMA_LANGUAGE;
  });

  const cinema = computed(() => {
    const param = route.params?.cinemaslug;
    return isValidCinemaSlug(param) ? param : DEFAULT_CINEMA_HANDLER;
  });

  const buildUrl = (path?: string) => {
    if (!path) return `/${lang.value}/${cinema.value}`;
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    return `/${lang.value}/${cinema.value}${normalizedPath}`;
  };

  const getUrl = (path?: string) => endingSlash(buildUrl(path));

  return { lang, cinema, buildUrl, getUrl };
};
